<template>
  <div>
    <v-col class="justify-center" sm="12" md="12" lg="12">
      <v-simple-table class="iol-v2-results">
        <template v-slot:default>
          <thead>
            <tr>
              <th>{{ fields.th1 || '--' }}</th>
              <th>{{ fields.th2 || '--' }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ fields.power || '--' }}</td>
              <td>{{ fields.es || '--' }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </div>
</template>

<style>
.iol-v2-results.v-data-table {
  border: 1px solid #000 !important;
  border-radius: 3px !important;
  background-color: inherit !important;
  text-align: center !important;
}
.iol-v2-results.v-data-table thead tr th {
  background-color: #c4c4c4 !important;
  color: #000 !important;
  font-size: 18px !important;
  font-style: bold !important;
  text-align: center !important;
}
.iol-v2-results.v-data-table tr > td:first-child {
  border-right: 1px solid #000 !important;
}
.iol-v2-results.v-data-table th:first-child {
  border-right: 1px solid #000 !important;
}
.iol-v2-results.v-data-table tfoot tr td {
  background-color: #c4c4c4 !important;
  color: #000 !important;
  font-size: 18px !important;
  font-style: bold !important;
  text-align: center !important;
}
.iol-v2-results.v-data-table tfoot tr > td:first-child {
  border-right: 0px solid #000 !important;
}
</style>

<script>
export default {
  name: 'iol-result-table',
  props: ['fields'],
  data() {
    return {
      field: this.fields,
    }
  },
  created() {
    this.$emit('fields', this.field)
  },
}
</script>
